import React, { useEffect, useState } from "react";
import columns from "../../../columns/clients/invoice.js";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import { GetClientInvoice } from "../../../api/request/clients/clients.js";
import moment from "moment";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import Delete from "../../../assets/Delete.jsx";
import { DeleteInvoiceApi } from "../../../api/request/taskManager/taskManager.js";
import toast from "react-hot-toast";
import { Tag } from "antd";

const Invoice = ({ id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);

  const openDeleteInvoiceModal = (item) => {
    setIsInvoiceOpen(true);
    setSelectedOrg(item);
  };

  const deleteInvoice = async () => {
    if (!selectedOrg) return;
    try {
      setIsInvoiceLoading(true);
      const params = {
        ...(selectedOrg?.is_extra_invoice
          ? { invoice_id: selectedOrg?.id, is_extra_invoice: true }
          : {
              invoice_temp_id: selectedOrg?.invoice_temp_id,
              organizer_id: selectedOrg?.organizer_id,
            }),
      };
      const { data } = await DeleteInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsInvoiceOpen(false);
        setInvoiceList(
          invoiceList?.filter((item) =>
            item?.is_extra_invoice
              ? item?.id !== selectedOrg?.id
              : item?.invoice_temp_id !== selectedOrg?.invoice_temp_id,
          ),
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsInvoiceLoading(false);
    }
  };

  const getInvoiceList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetClientInvoice({ client_id: id });
      if (data?.status) {
        setInvoiceList(
          data?.data?.map((item) => {
            return {
              ...item,
              // organizer: item?.organizer?.organizer_name_slug,
              organizer: item?.is_extra_invoice ? (
                <div className="flex gap-2 items-center">
                  <p>{item?.invoice_temp_name}</p>
                  <Tag color="red" className="mt-1">
                    External
                  </Tag>
                </div>
              ) : (
                item?.organizer?.organizer_name_slug
              ),
              amount: parseFloat(item?.amount).toFixed(2),
              status: (
                <p
                  className={`font-bold uppercase ${
                    item?.is_payment === "Paid"
                      ? "text-green-500"
                      : "text-red-600"
                  }`}
                >
                  {item?.is_payment}
                </p>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "--",
              action: (
                <div className="flex items-center gap-2">
                  <a
                    href={
                      (item?.is_extra_invoice
                        ? item?.invoice_path
                        : item?.organizer?.invoice_pdf) || "#"
                    }
                    target={"_blank"}
                    title={
                      item?.invoice_path || item?.organizer?.invoice_pdf
                        ? "View"
                        : "No Invoice"
                    }
                    className={`font-medium text-blue-400 underline ${item?.invoice_path || item?.organizer?.invoice_pdf ? "" : "cursor-not-allowed"}`}
                  >
                    View
                  </a>
                  {item?.is_payment !== "Paid" && (
                    <div
                      onClick={() => openDeleteInvoiceModal(item)}
                      title="Delete Invoice"
                    >
                      <Delete />
                    </div>
                  )}
                </div>
              ),
            };
          }),
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInvoiceList();
  }, []);

  return (
    <>
      <div className="h-[calc(100vh-146px)] overflow-y-auto">
        <SkeletonTable
          columns={columns}
          data={invoiceList}
          isLoading={isLoading}
        />
      </div>

      <ConfirmationModal
        isOpen={isInvoiceOpen}
        setIsOpen={setIsInvoiceOpen}
        message="Are you sure, want to delete this invoice?"
        onConfirm={deleteInvoice}
        isLoading={isInvoiceLoading}
        loadingLabel="Deleting..."
      />
    </>
  );
};

export default Invoice;
